import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { DatePipe, NgClass } from '@angular/common';
import { I18nModule, UrlModule } from '@spartacus/core';
import { NoItemsDisclaimerComponent } from '../../custom-make-a-payment/no-items-disclaimer/no-items-disclaimer.component';
import { SpinnerModule } from '@spartacus/storefront';
import { StatementsDateMap } from '../model/statment.model';
import { StatementsPdfDownloadComponent } from '../statements-pdf-download/statements-pdf-download.component';
import { SalesOrg } from '../../shared/config/app.config';

@Component({
  selector: 'sanofi-statements-list',
  imports: [
    I18nModule,
    NoItemsDisclaimerComponent,
    SpinnerModule,
    UrlModule,
    DatePipe,
    StatementsPdfDownloadComponent,
    NgClass
  ],
  templateUrl: './statements-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatementsListComponent {
  statementsList = input.required<StatementsDateMap[]>();
  isLoading = input<boolean>(false);
  isCustomerEmulated = input.required<boolean>();
  accountId = input.required<string>();
  widgetView = input(false);
  salesOrg = input.required<SalesOrg>();

  onStatementView = output<StatementsDateMap>();

  openStatements(dateMap: StatementsDateMap): void {
    this.onStatementView.emit(dateMap);
  }
}
